$(document).on('click','#restablecerClasificacionAutomatica',function() {
    $.post('/api/campeonato_grupo/'+$(this).data('id_reg_campeonatos_grupo')+'/liga/clasificacion/restablecerClasificacionAutomatica',{},function(res){
        $("#classificacio_container").html(res);
        var alert = $("#classificacio_container #restablecerClasificacionAutomatica").parent('.alert');
        $(alert).find('.response').remove();
        $(alert).append('<div class="alert alert-success response">'+Lang.get('msg.CambiosRealizadosCorrectamente')+'</div>');
        setTimeout(function () {
            $(alert).find('.response').remove();
        }, 3000);
    })
});


$(document).on('click','table .clasificacionEmpatado',function(){
    var id_reg_equipos = $(this).parent('.btn-group-vertical').data('id_reg_equipos');
    var desempate = $(this).parent('.btn-group-vertical').data('desempate');
    var tipo = $(this).data('tipo');
    var data = {
        'tipo':tipo,
        'desempate': desempate
    };
    $.post('/api/campeonato_grupo/liga/clasificacion/equipo/'+id_reg_equipos+'/posicion_desempate',data,function(res){
        $("#classificacio_container").html(res);
    })
});